import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { formatErr } from "../lib/api";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("admin@mahasa.dk");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && typeof user === "object") return <Navigate to="/admin/overblik" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (e2) {
      setErr(formatErr(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-5 bg-zinc-950" data-testid="login-page">
      <div className="lg:col-span-2 flex items-center justify-center px-8 py-12 bg-[#1A1A1A] border-r border-zinc-800">
        <div className="w-full max-w-sm">
          <div className="overline mb-2">Mahasa</div>
          <h1 className="headline text-5xl mb-2">Flådestyring.</h1>
          <p className="text-zinc-500 mb-10 text-sm">
            Overblik over din flåde, service, og økonomi.
          </p>
          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="overline">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="rounded-none border-zinc-700 bg-zinc-900 focus-visible:ring-1 focus-visible:ring-white mt-2"
                data-testid="login-email-input"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="overline">Adgangskode</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="rounded-none border-zinc-700 bg-zinc-900 focus-visible:ring-1 focus-visible:ring-white mt-2"
                data-testid="login-password-input"
                required
              />
            </div>
            {err && <div className="text-sm text-red-400" data-testid="login-error">{err}</div>}
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-white text-black py-3 font-semibold tracking-wide flex items-center justify-center gap-2 hover:bg-zinc-200 transition-colors disabled:opacity-50"
              data-testid="login-submit-button"
            >
              {loading && <Loader2 className="w-4 h-4 animate-spin" />}
              Log ind
            </button>
          </form>
          <p className="overline mt-12 text-zinc-600">Mahasa · 2026</p>
        </div>
      </div>
      <div
        className="hidden lg:block lg:col-span-3 bg-cover bg-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.85)), url('https://images.unsplash.com/photo-1580014317999-e9f1936787a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600')",
        }}
      >
        <div className="h-full w-full flex flex-col justify-end p-16 text-white">
          <div className="overline text-zinc-300">2026 Edition</div>
          <h2 className="headline text-6xl mt-4">Hold styr på din flåde.</h2>
          <p className="mt-4 max-w-md text-zinc-300 text-sm leading-relaxed">
            Service, kilometerstand, faste omkostninger og indtjening — alt på ét sted.
          </p>
        </div>
      </div>
    </div>
  );
}
